import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min, max } from '../../../theme/breakpoints';

export const ContentWrapper = styled(motion.div)`
  padding: 1rem;
  background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.OuterSpace : theme.colors.RipeLemon)};

  > .section-wrapper {
    margin: 0 auto;
    padding: 0 0 1rem 0;

    > p {
      color: ${({ theme }) => theme.colors.text};
      margin-top: 2.5rem;
      font-size: 0.875rem;

      @media screen and ${max('tablet')} {
        margin-top: 1.5rem;
        font-size: 0.75rem;
      }
    }
  }
`;

export const PromoCardsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and ${max('largeTablet')} {
    flex-direction: row;
    align-items: flex-start;
  }

  @media screen and ${max('mobile')} {
    flex-direction: column;
    align-items: center;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: 1.5rem;

  @media screen and ${min('desktop')} {
    margin-bottom: 3.125rem;
  }
  h3 {
    font-size: 1.5625rem;

    @media screen and ${min('desktop')} {
      font-size: 2.5rem;
    }
  }
`;
